module.exports = __webpack_public_path__ + "img/e4.30a6841c.png";